import React from 'react';
import { Card } from '../ui';
import './StoryCard.css';

/**
 * StoryCard component for displaying a story in the home view
 * 
 * @param {Object} props - Component props
 * @param {Object} props.story - Story data with standardized format {data: {...}}
 * @param {function} props.onClick - Click handler function
 */
const StoryCard = ({ story, onClick }) => {
  if (!story) return null;

  // Extract data from standardized format
  const storyData = story.data || story;
  
  const { title, id, pages = [] } = storyData;
  const totalPages = storyData.total_pages || 10; // Default to 10 if not specified
  const completedPages = pages.length;
  const progress = Math.floor((completedPages / totalPages) * 100);
  
  // Use first page image as card image if available and image is completed
  const firstPage = pages.length > 0 ? pages[0] : null;
  // Only use image if it's completed and has URL
  // Prefer permanent_image_url if available, otherwise fall back to image_url
  const imageUrl = (firstPage?.image_status === 'completed') 
    ? (firstPage?.permanent_image_url || firstPage?.image_url) 
    : null;

  return (
    <Card 
      interactive
      className="story-card"
      onClick={() => onClick(id)}
    >
      <div className="story-card__content">
        {imageUrl && (
          <div className="story-card__image-container">
            <img src={imageUrl} alt={title} className="story-card__image" />
          </div>
        )}
        
        <h3 className="story-card__title">{title}</h3>
        
        <div className="story-card__progress">
          <div className="story-card__progress-bar">
            <div 
              className="story-card__progress-fill" 
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="story-card__progress-text">
            {completedPages} / {totalPages} pages
          </span>
        </div>
      </div>
    </Card>
  );
};

export default StoryCard;